import { Injectable } from '@angular/core';
import { Infracao, InfracaoMotivo } from '@tivic-team/manager-ts/dist/mob';
import { HttpGet, HttpResponse, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';

@Injectable()
export class InfracaoMotivoController{

    constructor() { }

    async getAll():Promise<Array<Infracao>> {
        let quark = new Quark (
            new HttpGet ({
                url: new Url ({
                    id: 'mob/infracao-motivo',
                    environment: environment
                }),
            }),
            new HttpResponse (
                new Array<Infracao>()
            )
        );
        return await quark.call();
    }

    async findMotivos(filtros?: IFilter): Promise<Array<InfracaoMotivo>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/infracao-motivo/motivos',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<InfracaoMotivo>()
            )
        );
        return await quark.call();
    }

}